export default "__VITE_ASSET__BTcgrlnf__"